module.exports = __webpack_public_path__ + "img/undraw_process_e90d.71b62565.svg";